/* @flow */

import { enableInitializing } from 'initializable-reducer';
import type { Action } from '../diplomatico/types';

const initialState = {
  active: false,
  student: {}
};

function studentEditModal(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'SHOW_STUDENT_EDIT_MODAL':
      return {
        active: true,
        ...payload
      };
    case 'HIDE_STUDENT_EDIT_MODAL':
      return { ...initialState };
    case 'SET_MODAL_STUDENT':
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
}

export {
  studentEditModal,
  initialState
};

export default enableInitializing(studentEditModal);
